import React, { Suspense } from 'react';

const OptimizedInviteForm = React.lazy(() =>
  // @ts-ignore
  import('./optimized-invite-members-form')
);

export default function InviteTeammatesStep(props) {
  return (
    <>
      <Suspense fallback={null}>
        <OptimizedInviteForm {...props} />
      </Suspense>
    </>
  );
}
